import { axiosUser } from "./axiosInstance";

/*
 * Customer support — see lk-mobile-backend/docs/SUPPORT_SYSTEM_SPEC.md §2.
 * Every call is the signed-in customer's own cases only.
 */

const data = (res) => res?.data?.data ?? res?.data;

export const getSupportCategories = async (bookingId) =>
  data(await axiosUser.get("/support/categories", { params: bookingId ? { bookingId } : {} })) || [];

export const listSupportCases = async ({ status = "all", page = 1, limit = 30 } = {}) =>
  data(await axiosUser.get("/support/cases", { params: { status, page, limit } }));

export const createSupportCase = async (payload) => data(await axiosUser.post("/support/cases", payload));

export const getSupportCase = async (id) => data(await axiosUser.get(`/support/cases/${id}`));

export const sendSupportMessage = async (id, payload) =>
  data(await axiosUser.post(`/support/cases/${id}/messages`, payload));

export const markSupportCaseRead = async (id) => data(await axiosUser.post(`/support/cases/${id}/read`));

export const reopenSupportCase = async (id, reason) =>
  data(await axiosUser.post(`/support/cases/${id}/reopen`, { reason }));

export const getRefundPreview = async (id, type) =>
  data(await axiosUser.get(`/support/cases/${id}/refund-preview`, { params: { type } }));

export const requestRefund = async (id, payload) =>
  data(await axiosUser.post(`/support/cases/${id}/refund-request`, payload));

export const rateSupportCase = async (id, payload) =>
  data(await axiosUser.post(`/support/cases/${id}/feedback`, payload));

export const getSupportUnreadCount = async () => {
  const d = data(await axiosUser.get("/support/unread-count"));
  return Number(d?.count) || 0;
};

/** The URL the backend stores for an upload: <API>/media/<resourcePath>. */
export const mediaUrl = (path) => {
  if (!path) return "";
  if (/^(https?:)?\/\//i.test(path) || path.startsWith("blob:") || path.startsWith("data:")) return path;
  const base = (import.meta.env.VITE_API_BASE_URL || "").replace(/\/$/, "");
  return `${base}/media/${encodeURIComponent(path)}`;
};

/** Upload one file; resolves to the attachment shape a case message carries. */
export const uploadAttachment = async (file) => {
  const form = new FormData();
  form.append("file", file);
  const res = await axiosUser.post("/media/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const path = data(res)?.resourcePath;
  if (!path) throw new Error("Upload failed");
  return { url: mediaUrl(path), name: file.name, mime: file.type || "application/octet-stream", size: file.size };
};
